<template>
  <v-card
    class="mx-auto my-12"
    max-width="900"
  >

 <template >
                  <v-toolbar color="grey lighten-2">
             <v-row>
                    <v-col  cols="12" md="4">
                      <v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>
    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
   <b>  Cadastrar   <span>Instituição</span> </b>
     </v-col>
      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>
  </v-row>

                  </v-toolbar>

              </template>
               <v-card-title>Informações da Instituição</v-card-title>
    <v-card-text>
      <v-row
        align="center"
        class="mx-0"
      >
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>
      </v-row>
<v-row>
        <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.nomeInstituicao"
             label="Nome da Instituição"
            ></v-text-field>
          </v-col>

 </v-row>
 <v-row>
    <v-col  cols="12" md="4">
            <v-text-field
            :rules="ruleTextRequired"
             v-model="editedItem.sigla"
             label="Sigla da Instituição"
            ></v-text-field>
          </v-col>
          <v-col  cols="12" md="4">
  <v-file-input multiple label="Logotipo da Instituição"></v-file-input>
  </v-col>
          </v-row>
    </v-card-text>
     <v-divider class="mx-4"></v-divider>

    <v-card-title>Membros Directivos da Instituição</v-card-title>

<v-card-text>
      <v-row>
      <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.nomeDg"
             label="Nome do Director Geral"
            ></v-text-field>
          </v-col>
          <v-col  cols="12" md="4">
            <v-text-field
            :rules=" ruleEmailRequired"
            v-model="editedItem.emailDg"
             label="Email do Director Geral"
            ></v-text-field>
          </v-col>
           <v-col  cols="12" md="4">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.telefoneDg"
             label="Telefone do Director Geral"
            ></v-text-field>
          </v-col>
          </v-row>
          <v-row>
      <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.nomeDp"
             label="Nome do Director Pedagogico"
            ></v-text-field>
          </v-col>
          <v-col  cols="12" md="4">
            <v-text-field
            :rules=" ruleEmailRequired"
            v-model="editedItem.emailDp"
             label="Email do Director Pedagogico"
            ></v-text-field>
          </v-col>
           <v-col  cols="12" md="4">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.telefoneDp"
             label="Telefone do Director Pedagogico"
            ></v-text-field>
          </v-col>
           </v-row>
    </v-card-text>
    <v-divider class="mx-4"></v-divider>

    <v-card-title>Usuario Principal</v-card-title>

    <v-card-text>
      <v-row>
      <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.nomeUsuario"
             label="Usuario Principal"
            ></v-text-field>
          </v-col>
          <v-col  cols="12" md="4">
            <v-text-field
            :rules=" ruleEmailRequired"
            v-model="editedItem.emailUsuario"
             label="Email do usuario Principal"
            ></v-text-field>
          </v-col>
          </v-row>
          <v-row>
      <v-col  cols="12" md="6">
            <v-text-field
            :rules=" ruleTelefone"
            v-model="editedItem.telefoneUsuario"
             label="Telefone do Usuario Principal"
            ></v-text-field>
          </v-col>
           </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  directives: { mask },
  data: () => ({
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos e',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    ruleTelefone: [
      value => value.length === 9 || 'Minimo de caracteres exigido( 9 ).'
    ],
    valid: true,
    editedItem: {
      nomeInstituicao: '',
      sigla: '',
      nomeDg: '',
      telefoneDg: '',
      nomeDp: '',
      telefoneDp: '',
      emailDg: '',
      emailDp: '',
      nomeUsuario: '',
      emailUsuario: '',
      telefoneUsuario: ''

    },
    defaultItem: {
      nomeInstituicao: '',
      sigla: '',
      nomeDg: '',
      telefoneDg: '',
      nomeDp: '',
      telefoneDp: '',
      emailDg: '',
      emailDp: '',
      nomeUsuario: '',
      emailUsuario: '',
      telefoneUsuario: ''
    }
  }),
  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {

  },

  methods: {

    async close () {
      this.$router.push('/ConfirmarInstituicao')
    },
    async save () {
      var params = {
        idInstituicaoP: 0,
        descricaoP: this.editedItem.nomeInstituicao,
        siglaP: this.editedItem.sigla,
        nomeDgP: this.editedItem.nomeDg,
        emailDgP: this.editedItem.emailDg,
        telefoneDgP: this.editedItem.telefoneDg,
        nomeDpP: this.editedItem.nomeDp,
        emailDpP: this.editedItem.emailDp,
        telefoneDpP: this.editedItem.telefoneDp,
        userMainP: this.editedItem.nomeUsuario,
        emailUserP: this.editedItem.emailUsuario,
        telefoneUserP: this.editedItem.telefoneUsuario
      }

      try {
        let msg = await axios
          .post('/InsertOrUpdateInstituicaoPendente', params)
          .then(res => res.data)

        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
          this.$router.push('/ConfirmarInstituicao')
        }
      } catch (error) {}
    }
  }
}

</script>
